import Flickity from "flickity";

document.addEventListener("alpine:init", () => {
    Alpine.data("largeImageSlider", (autoplay, infinite) => ({
        autoplay: false,
        infinite: false,
        slider: null,
        sliderContainer: null,
        totalWidth: 0,
        slideXTotal: 0,
        videoPlaying: true,
        selectedIndex: 0,
        loading: true,
        progressInterval: null,

        init() {
            this.sliderContainer = this.$refs.slider;
            const slides = this.sliderContainer.querySelectorAll(".slide");

            let options = {
                cellAlign: "left",
                contain: true,
                wrapAround: this.infinite,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
                autoPlay: false,
                on: {
                    settle: () => {
                        this.updateTabIndexes(slides);
                    },
                    change: () => {
                        this.selectedIndex = this.slider.selectedIndex;
                        this.startProgressBar();
                    },
                },
            };

            this.slider = new Flickity(this.sliderContainer, options);

            this.getSlideXTotal(slides);
            this.updateTabIndexes(slides);
            this.updateProgressBar();
            this.startProgressBar();

            pegasus.onResizeFinished(() => {
                this.totalWidth = 0;
                this.getSlideXTotal(slides);
                this.updateProgressBar();
            });

            this.slider.on("scroll", (e) => {
                this.updateProgressBar();
            });
        },

        getSlideXTotal(slides) {
            slides.forEach((slide) => {
                this.totalWidth += slide.offsetWidth;
            });

            if (this.infinite) {
                this.slideXTotal = (this.totalWidth - this.sliderContainer.offsetWidth) + ((this.sliderContainer.offsetWidth / 2) + (this.totalWidth / slides.length));
            } else {
                this.slideXTotal = this.totalWidth - this.sliderContainer.offsetWidth;
            }
        },

        updateTabIndexes(slides) {
            slides.forEach((slide) => {
                const slideElements = slide.querySelectorAll("a, button");

                slideElements.forEach((element) => {
                    if (slide.classList.contains("is-selected")) {
                        element.removeAttribute("tabindex");
                    } else {
                        element.setAttribute("tabindex", "-1");
                    }
                });
            });
        },

        updateProgressBar() {
            const progressBar = this.$refs.progressBar;
            if (!progressBar) return;
            const progress = (Math.abs(this.slider.x) / this.slideXTotal) * 100;
            progressBar.style.width = progress + "%";
        },

        
        startProgressBar() {
            clearInterval(this.progressInterval);
        
            const progressIndicators = this.$el.querySelectorAll('.slide-progress');
            progressIndicators.forEach((progressElement, index) => {
                const progressBar = progressElement.querySelector('.progress');
        
                if (index === this.selectedIndex) {
                    progressElement.classList.add('active');
                    progressBar.style.width = '0';
                    setTimeout(() => {
                        progressBar.style.width = '100%';
                    }, 5);
                } else {
                    progressElement.classList.remove('active');
                    progressBar.style.width = '0';
                }
            });
        
            this.progressInterval = setTimeout(() => {
                if (this.selectedIndex < this.slider.slides.length - 1) {
                    this.slider.next();
                } else {
                    this.slider.select(0);
                }
            }, 4000);
        }
        

    }));
});
